<template>
    <div>
        <div class="space-y-4">
            <div class="grid grid-cols-1 gap-4">
                <div class="col-span-1">
                    <field-value title="Total Amount">{{ convertValue(data.amount) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Capital Call Today">{{ convertValue(data.capital_call_today) }}</field-value>
                </div>

                <div v-if="series != 'nsight'" class="col-span-1">
                    <field-value title="True Up Dollar Amount">{{ convertValue(data.true_up_dollar) }}</field-value>
                </div>
            </div>

            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div class="col-span-1 sm:col-span-2">
                    <heading-title class="!mb-0">How do you want to fund your investment now?</heading-title>
                </div>

                <div class="col-span-1 uppercase sm:col-span-2">
                    <field-value>{{ convertValue(data.fund.which) }}</field-value>
                </div>
            </div>

            <div v-if="data.fund.which == 'ach'" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div class="col-span-1 sm:col-span-2">
                    <heading-title class="!mb-0">ACH Fund Account</heading-title>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Holder Name">{{ convertValue(data.fund.accountName) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Nickname">{{ convertValue(data.fund.nickname) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Type">{{ convertValue(data.fund.accountType) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Number">{{ convertValue(data.fund.accountNumber) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Routing Number">{{ convertValue(data.fund.routingNumber) }}</field-value>
                </div>
            </div>

            <div v-if="data.fund.which == 'ach'" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div class="col-span-1 sm:col-span-2">
                    <heading-title class="!mb-0">ACH Transfer to Fund Your Account</heading-title>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Holder Name">{{ convertValue(data.fund.accountName) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Nickname">{{ convertValue(data.fund.nickname) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Type">{{ convertValue(data.fund.accountType) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Account Number">{{ convertValue(data.fund.accountNumber) }}</field-value>
                </div>

                <div class="col-span-1">
                    <field-value title="Routing Number">{{ convertValue(data.fund.routingNumber) }}</field-value>
                </div>
            </div>

            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <template v-if="data.fee.which != 'Yes'">
                    <div class="col-span-1 sm:col-span-2">
                        <heading-title class="!mb-0">ACH Admin Fee Transfer Account</heading-title>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Holder Name">{{ convertValue(data.fee.accountName) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Nickname">{{ convertValue(data.fee.nickname) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Type">{{ convertValue(data.fee.accountType) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Number">{{ convertValue(data.fee.accountNumber) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Routing Number">{{ convertValue(data.fee.routingNumber) }}</field-value>
                    </div>
                </template>

                <template v-else>
                    <div class="col-span-1 sm:col-span-2">
                        <heading-title class="!mb-0">Use this account to pay for my annual <span v-if="series == 'nsight'">$500</span><span v-else>$399</span> administration fee?</heading-title>
                    </div>

                    <div class="col-span-1">
                        <field-value>{{ convertValue(data.fee.which) }}</field-value>
                    </div>
                </template>
            </div>

            <div v-if="data.fund.which != 'ira'" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <template v-if="data.distribution.which != 'Yes'">
                    <div class="col-span-1 sm:col-span-2">
                        <heading-title class="!mb-0">ACH Distribution Account</heading-title>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Holder Name">{{ convertValue(data.distribution.accountName) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Nickname">{{ convertValue(data.distribution.nickname) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Type">{{ convertValue(data.distribution.accountType) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Account Number">{{ convertValue(data.distribution.accountNumber) }}</field-value>
                    </div>

                    <div class="col-span-1">
                        <field-value title="Routing Number">{{ convertValue(data.distribution.routingNumber) }}</field-value>
                    </div>
                </template>

                <template v-else>
                    <div class="col-span-1 sm:col-span-2">
                        <heading-title class="!mb-0">Use this account to for your distributions and credits?</heading-title>
                    </div>

                    <div class="col-span-1">
                        <field-value>{{ convertValue(data.distribution.which) }}</field-value>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import HeadingTitle from '@Components/HeadingTitle.vue'
import FieldValue from '@Components/FieldValue.vue'
import { convertIntakeValue } from '@/utils'
import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from '@vue/reactivity'

export default {
    components: {
        HeadingTitle,
        FieldValue
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    setup(props){
        const pageData = usePage().props.value
        const userData = _.get(pageData, 'auth.user')

        const series = computed(() => {
            return _.get(userData, 'series_type', 'default')
        })

        function convertValue(value){
            return (value) ? convertIntakeValue(value) : '-'
        }

        return {
            series,
            convertValue
        }
    }
}
</script>

<style>

</style>
